import { DataColumns } from '../DataColumns/DataColumns';
import {
  TenantFilterCell,
  GridDateCell,
  BooleanFlagFilterCell,
} from '../../../../Core/Components/Filter/FilterElements';
import GridFlag from '../../../../Core/Components/GridFlag/GridFlag';
import { MultiViewCalenderFilterCell, DateRangeFilterCell } from 'smart-react';
/**
 * Generates a list of columns for a grid.
 * @param {object} options - The options for the grid.
 * @returns {Array} - The list of grid columns.
 */
export const GridColumnsList = async ({
  editContentSlider,
  dateRangefilter,
  setDateRangeFilter,
}) => {
  return DataColumns({
    editContentSlider,
    TenantFilterCell,
    DateRangeFilterCell,
    dateRangeFilter: dateRangefilter,
    setDateRangeFilter,
    GridDateCell,
    MultiViewCalenderFilterCell,
    BooleanFlagFilterCell,
    GridFlag,
  });
};

export default GridColumnsList;
